/* eslint-disable no-nested-ternary */
import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader, Select, SelectOption,
} from 'appkit-react';

import '../styles/share-files.scss';

const ShareFiles = ({
    visible, setVisible, selectedUser, userError, inputHandler, onSave, loading, users, inputTypes,
}) => {
    const containFolderAndFiles = () => (inputTypes.includes('directory') && inputTypes.includes('file'));

    const containFolders = () => (inputTypes.includes('directory'));

    const getFoldersAndFilesText = () => {
        let text;
        if (containFolderAndFiles()) {
            text = 'folders and files';
        } else if (containFolders()) {
            text = 'folder(s)';
        } else {
            text = 'file(s)';
        }
        return text;
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal"
                visible={visible}
                onCancel={() => { setVisible(false); }}
                style={{ marginTop: '5rem' }}
                backdropClosable={false}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">
                                Share
                                {inputTypes.length > 1 ? ' multiple ' : ''}
                                {getFoldersAndFilesText()}
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="data-recon-share-files-modal">
                        <div>
                            <Select
                                placeholder="Select user"
                                onSelect={e => inputHandler(e)}
                                showSearchOnList
                                value={selectedUser}
                                name="selectedUser"
                            >
                                {
                                    users && users.map(user => <SelectOption key={user.userId} value={user.userId}>{user.fullName}</SelectOption>)
                                }
                            </Select>
                            {userError && <div className="user-error-message">Please select the user.</div>}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter style={{ justifyContent: 'flex-end' }}>
                    <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> Cancel </Button>
                    <Button kind="primary" size="lg" onClick={onSave} isLoading={loading}> Share </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ShareFiles;
